import { StyleObject } from 'styletron-react';
import { paddingSize } from '../../Utilities/utils/Theming';


const PopoverFontSize: { [key: string]: string } = {
	large: 'var(--epods--popover-large-font-size)',
	default: 'var(--epods--popover-default-font-size)',
	compact: 'var(--epods--popover-compact-font-size)',
	mini: 'var(--epods--popover-mini-font-size)',
};

const PopoverLineHeight: { [key: string]: string } = {
	large: 'var(--epods--popover-large-line-height)',
	default: 'var(--epods--popover-default-line-height)',
	compact: 'var(--epods--popover-compact-line-height)',
	mini: 'var(--epods--popover-mini-line-height)',
};

export const tooltipBaseStyle = ($theme: any, props: any) => {

	const isPresetPopoverFontSize = ['large', 'default', 'compact', 'mini'].includes(props.size);
	const fontSize = isPresetPopoverFontSize ? PopoverFontSize[props.size] : props.size;

	const isPresetPopoverLineHeight = ['large', 'default', 'compact', 'mini'].includes(props.size);
	const lineHeight = isPresetPopoverLineHeight ? PopoverLineHeight[props.size] : props.size;

	return {
		backgroundColor: 'var(--epods--color-bg-overlays)',
		fontFamily: 'var(--epods--font-base)',
		color: 'var(--epods--color-text-inverted)',
		border: 'none',
		...paddingSize(
			'var(--epods--space-inset-xs)', //$theme.tooltip.tooltipPaddingTopBottom,
			'var(--epods--space-inset-s)', //$theme.tooltip.tooltipPaddingLeftRight,
			'var(--epods--space-inset-xs)', //$theme.tooltip.tooltipPaddingTopBottom,
			'var(--epods--space-inset-s)', //$theme.tooltip.tooltipPaddingLeftRight,
		),
		fontSize: fontSize,
		lineHeight: lineHeight,
		zIndex: 'var(--epods--zindex-tooltip)' as any,
		':hover': {
			cursor: 'pointer',
		},
	};
};

export const tooltipArrow = ($theme: any) => {
	return {
		backgroundColor: 'var(--epods--color-bg-overlays)',
	};
};

export const tooltipBody = ($theme: any) => {
	return {
		boxShadow: '0 1px 2px rgba(94, 124, 143, 0.4)',
		'@media print': {
			visibility: 'hidden',
		},
	} as StyleObject;
};
